export const API_URL = "https://dev.api.sharemonkie.com/api";
export default API_URL;
